import { useState } from 'react';

export function Switch({
  checked,
  disabled,
  label,
  onChange,
}: {
  checked: boolean;
  disabled?: boolean;
  label: string;
  onChange?: (next: boolean) => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className="setd-switch"
      onClick={() => {
        onChange?.(!checked);
      }}
    />
  );
}

/** Switch that keeps its own on/off state (mock pages with no persistence). */
export function LocalSwitch({ initial, label, disabled }: { initial: boolean; label: string; disabled?: boolean }) {
  const [on, setOn] = useState(initial);
  return <Switch checked={on} disabled={disabled ?? false} label={label} onChange={setOn} />;
}

export function SectionHeader({ n, title, meta }: { n: string; title: string; meta?: string }) {
  return (
    <div className="setd-sec">
      {n ? <span className="setd-sec-no">{n}</span> : null}
      <h2 className="setd-sec-title">{title}</h2>
      {meta ? <span className="setd-sec-meta">{meta}</span> : null}
    </div>
  );
}

export type PillKind = 'ok' | 'warn' | 'mute' | 'ready' | 'on' | 'off' | 'bad';

export function Pill({ kind, children }: { kind: PillKind; children: React.ReactNode }) {
  return <span className={`setd-pill ${kind}`}>{children}</span>;
}

export function ChangeLine({ by, org, date }: { by: string; org: string; date: string }) {
  return (
    <div className="setd-change">
      Only owners and admins can change these. Last change: {by} ({org}), {date}.
    </div>
  );
}
